<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <WorkTypeCategoryTableItem v-for="item in workTypeCategoryGrid" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkTypeCategoryTableItem from 'components/setting/workTypeCategory/WorkTypeCategoryTableItem'
export default {
  props: ['workTypeCategoryGrid'],
  components: { WorkTypeCategoryTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-work_type_category']['tables'][
            'tip-proekta'
          ],
        },
        {
          text: this.localStorage.translations.pages['setting-work_type_category']['tables'][
            'nazvanie-kategorii'
          ],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
